/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("VBoxController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class VBoxController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class VBoxController extends cls.ControllerBase /** @lends classes.VBoxController.prototype */ {
    static __name = "VBoxController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.Reverse4STBehavior);
      this._addBehavior(cls.Packed4STBehavior);

      // vm behaviors
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.SplitterVMBehavior);
      this._addBehavior(cls.OrientationVMBehavior);
      this._addBehavior(cls.SplitVMBehavior);
      this._addBehavior(cls.NoSwipeVMBehavior);
      this._addBehavior(cls.NavigationArrows4STBehavior);
      this._addBehavior(cls.NavigationDots4STBehavior);

      // ui behaviors
      this._addBehavior(cls.OnSplitterUIBehavior);
    }

    /**
     * @inheritDoc
     */
    ensureVisible(executeAction = false) {
      const widget = this.getAnchorNode().getWidget();
      widget.emit(context.constants.widgetEvents.splitViewChange, widget);
      return super.ensureVisible(executeAction);
    }
  }

  cls.VBoxController = VBoxController;
  cls.ControllerFactory.register("VBox", cls.VBoxController);
});
